/* eslint-disable */
import React, { useEffect, useState, memo, useCallback } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import FilterColumn from './filter_column'

const FilterCategory = () => {
    const selectCategory = useSelector(state => state.initial.selectCategory)
    const domain = useSelector(state => state.initial.domain)
    const mall_web_user = useSelector(state => state.initial?.minishopInfo?.mall_web_user)
    const { categoryData, currentCategory, objCateData } = useSelector(state => state.category)
    const [cateIndexArr, setCateIndexArr] = useState([])    // selectCategory index array
    const [cateListLength, setCateListLength] = useState(0)   // selectCategory의 child 수
    const selectCate = { ...currentCategory.reduce }
    const selectCateArr = [currentCategory.cate[0].cate_id,
        ...Object.keys(selectCate).map(v => selectCate[v]).filter(v => v)
    ]   // 대분류 포함된 selectcategory id array
    const prevSelectCate = selectCateArr[selectCateArr.length - 2]  // selectcategory 이전 카테고리id
    const prev2SelectCate = selectCateArr[selectCateArr.length - 3]  // selectcategory 이전전 카테고리id

    useEffect(() => {
        setCateIndex()
    }, [currentCategory.reduce])

    const setCateIndex = () => {
        const cateIndexArr = []

        selectCateArr.forEach((v, i) => {
            const selectIndex = () => {
                if (i === 0) return categoryData.findIndex(j => j.cate_id === v)
                else if (i === 1) return categoryData[cateIndexArr[0]].child.findIndex(j => j.cate_id === v)
                else if (i === 2) return categoryData[cateIndexArr[0]].child[cateIndexArr[1]].child.findIndex(j => j.cate_id === v)
                else if (i === 3) return categoryData[cateIndexArr[0]].child[cateIndexArr[1]].child[cateIndexArr[2]].child.findIndex(j => j.cate_id === v)
                else if (i === 4) return categoryData[cateIndexArr[0]].child[cateIndexArr[1]].child[cateIndexArr[2]].child[cateIndexArr[3]].child.findIndex(j => j.cate_id === v)
            }
            cateIndexArr[i] = selectIndex()
        })
        setCateIndexArr(cateIndexArr)
    }

    return (
        <FilterColumn title="카테고리" filterCategory>
            <div className="row">
                <div className="cell">
                    <h4 className="cell_title">
                        <div className="cell_title_cate">
                            <span>전체</span> &gt;{' '}
                            <Title cate={domain !== 'pc' ? currentCategory.cate[0] : currentCategory.cate[0].child[0]} mall_web_user={mall_web_user} />
                            <span className="num">{cateListLength}</span>
                        </div>
                    </h4>
                    <ul className="list">
                        {cateIndexArr.length > 0 && (
                            <List
                                objCateData={objCateData}
                                selectCategory={selectCategory}
                                prevSelectCate={prevSelectCate}
                                prev2SelectCate={prev2SelectCate}
                                setCateListLength={setCateListLength}
                                currentCategory={currentCategory}
                            />
                        )}
                    </ul>
                </div>
            </div>
        </FilterColumn>
    )
}

const Title = memo(({ cate, mall_web_user }) => {
    const selectCategory = useSelector(state => state.initial.selectCategory)

    return (
        <>
            {cate.f_clk
                ? selectCategory !== cate.cate_id
                    ? <Link to={`${mall_web_user ? '/' + mall_web_user : ''}/list/${cate.cate_id}`}>{cate.cate_name}</Link>
                    : <button type="button">{cate.cate_name}</button>
                : <button type="button">{cate.cate_name}</button>
            }
            {cate.child.length > 0 && <>{' '}&gt;{' '}</>}
            {cate.child.length > 0 && <Title cate={cate.child[0]} mall_web_user={mall_web_user} />}
        </>
    )
})

const List = memo(({ objCateData, selectCategory, prevSelectCate, prev2SelectCate, setCateListLength, currentCategory }) => {
    const mall_web_user = useSelector(state => state.initial?.minishopInfo?.mall_web_user)
    const basicLink = mall_web_user ? `/${mall_web_user}` : ''
    const selectCateObj = objCateData[selectCategory]
    const isLast = selectCateObj.child_count === 0

    const [cateItem, setCateItem] = useState([])

    const history = useHistory()

    useEffect(() => {
        const select = !isLast
        ? (
            selectCateObj.child
        )
        : (
            objCateData[prevSelectCate].child
        )
        setCateItem(select)
        setCateListLength(select.length)
    }, [currentCategory.reduce])

    const menuClick = useCallback(cate => {
        if (cate.f_clk === 0 && cate.child_count > 0) { // 선택한 카테고리가 클릭불가능이면 선택한 카테고리의 하위 첫번째 카테고리 선택
            history.push(`${basicLink}/list/${cate.child[0].cate_id}${window.location.search}`)
        } else if (selectCategory === cate.cate_id) {
            if (objCateData[prevSelectCate].f_clk === 0) {  // 이전 카테고리가 클릭불가능
                if (objCateData?.[prev2SelectCate]?.f_clk === 0) {  // 이전전 카테고리가 클릭불가능
                    return
                } else {    // 선택된 카테고리와 현재카테고리가 같고 이전 카테고리 클릭이 불가능이고 이전전 카테고리 클릭이 가능하면 이전전 카테고리로 이동
                    const cateId = objCateData[prev2SelectCate].cate_id
                    history.push(`${basicLink}/list/${cateId}${window.location.search}`)
                }
            } else {
                history.push(`${basicLink}/list/${prevSelectCate}${window.location.search}`) // 선택한 카테고리와 현재 카테고리가 같을시 이전 카테고리로 이동
            }
        } else {    // 선택한 카테고리로 이동
            history.push(`${basicLink}/list/${cate.cate_id}${window.location.search}`)
        }
    }, [selectCategory, prevSelectCate])

    const activeItem = useCallback(id => {
        if (!isLast) return ''
        return id === selectCategory ? 'active' : ''
    }, [selectCategory])

    return (
        cateItem.map((v) => (
            <li key={v.cate_id} className={activeItem(v.cate_id)}>
                {!v.lnk_url ? (
                    <button type="button" onClick={() => menuClick(v)}>
                        <span className="text">
                            {v.cate_name}
                        </span>
                        <i className="icon-close" />
                    </button>
                ) : (
                    <a href={v.lnk_url} target="_blank" rel="noopener noreferrer">
                        <span className="text">
                            {v.cate_name}
                        </span>
                    </a>
                )}
            </li>
        ))
    )
})

// 카테고리 상품개수 노출필요시
// <button type="button">
//     <span className="text">
//         {v.cate_name}
//         <span className="num">{v.cnt_item}</span> // 상품개수
//     </span>
//     <i className="icon-close" />
// </button>

export default memo(FilterCategory)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_category.js